import { Record } from 'immutable';

const StudentTasksRecord = Record({
  lessonNumber: undefined,
  sessionId: undefined,
  unitId: undefined,
  unitOrderingSequence: undefined,
  studentTaskResults: undefined,
});

class StudentTasks extends StudentTasksRecord { }

export default StudentTasks;



// WEBPACK FOOTER //
// ./data/StudentTasks/model.js